<template>
    <div class="top-companies">
        <img class="top-companies__throphy" :src="throphyImage" :alt="$t('alt.top_companies')" />
        <common-page-header
            size="small"
            :heading="$t('pages.home.home.widget.top_companies')"
            :isCenter="true"
        ></common-page-header>
        <common-loader :isProcessing="isProcessing"></common-loader>

        <div v-for="company in companies" :key="company.id" class="top-companies--item">
            <common-company-avatar
                :company="company"
                :withBorder="true"
                :shouldLeadToProfile="true"
                size="tiny-micro"
            ></common-company-avatar>
            <div class="top-companies--item__name" @click="companyNameClicked(company.id)">{{ company.name }}</div>
        </div>
    </div>
</template>

<script>
    import OfferAPI from 'api/OfferAPI'
    import RoutesEnum from 'enums/routes.enum'
    import Store from '~/store'

    export default {
        props: {
            isProcessing: { type: Boolean, default: false },
        },

        data() {
            return {
                companies: [],
                throphyImage: require('../../assets/images/throphy-gold.png'),
            }
        },

        computed: {
            countryByGeolocation() {
                return Store.getters['data/getCountryByGeolocation'] ?? 0
            },
        },

        methods: {
            getTopCompanies() {
                OfferAPI.getTopCompanies(this.countryByGeolocation).then((response) => {
                    this.companies = response
                })
            },

            companyNameClicked(companyId) {
                this.$router.push({ name: RoutesEnum.COMPANY.PROFILE, params: { id: companyId, companyType: 'profile' } })
            },
        },

        watch: {
            countryByGeolocation() {
                this.getTopCompanies()
            },
        },

        mounted() {
            this.getTopCompanies()
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    .top-companies {
        background: rgba(245, 245, 245, 0.44);
        border-radius: 20px;
        padding: 56px;
        position: relative;

        &__throphy {
            position: absolute;
            top: -20px;
            right: -20px;
            border-radius: 50%;
            width: 70px;
        }

        &--item {
            margin-top: 20px;
            display: flex;
            align-items: center;

            &__name {
                font-family: 'Poppins';
                font-style: normal;
                font-weight: 600;
                font-size: $font-size--hint;
                line-height: 18px;
                max-width: calc(100% - 60px);
                cursor: pointer;
            }

            .company-avatar {
                margin-right: 10px;
            }
        }
    }
</style>
